import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuotationContext } from '../contexts/QuotationContext';
import { Product } from '../graphql/types';
import { useQuotation } from '../helpers';
import {
  buildSearchStringWithAllQueryParams,
  buildUrl,
  getAllQueryParams,
} from '../helpers/queryparam';

type Props = {
  products: Product[];
};

const ActionPanel = ({ products }: Props) => {
  const { values, coupon, validateIssueAge, isSumAssuredValid, activeProduct } =
    useQuotationContext();
  const { button } = getAllQueryParams();
  const intl = useIntl();

  const url = activeProduct
    ? buildUrl(activeProduct.plan_details_url, values)
    : '';

  const [quotation] = useQuotation({
    productId: activeProduct.code,
    age: values.age,
    gender: values.gender,
    smoker: values.smoker,
    sumAssured: values.sumAssured,
  });
  const premium = quotation?.basic_premium || 0;

  const isIssueAgeValid = validateIssueAge(activeProduct, values.age);

  const onClick = () => {
    window.open(
      `${process.env.REACT_APP_APP_BASE_URL}/#/${
        intl.locale
      }/apply/new/?${buildSearchStringWithAllQueryParams({
        product_ids: activeProduct.code,
        coupon: coupon ? coupon.promo_code : '',
        ...values,
      })}`,
      '_blank',
    );
  };

  return (
    <Grid container spacing={3} justifyContent="space-between">
      {button !== '1' && (
        <Grid item xs={12} sm={6}>
          <Button
            disableRipple
            component="a"
            id="plan-details"
            href={url}
            target="_blank"
            color="secondary"
            variant="contained"
            fullWidth
          >
            {products.length > 1 ? (
              <FormattedMessage id="comparePlans" />
            ) : (
              <FormattedMessage id="planDetails" />
            )}
          </Button>
        </Grid>
      )}
      <Grid item xs={12} sm={button !== '1' ? 6 : 12}>
        <Button
          disableRipple
          component="a"
          id="application"
          onClick={onClick}
          color="primary"
          variant="contained"
          fullWidth
          disabled={!isIssueAgeValid || !isSumAssuredValid || !premium}
        >
          <FormattedMessage id="apply" />
        </Button>
      </Grid>
    </Grid>
  );
};

export default ActionPanel;
